import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search as SearchIcon } from "lucide-react";
import { api } from "@/lib/api";
import { colors } from "@/theme";
import { ProductCard } from "@/components/ProductCard";
import { ProductGridSkeleton, EmptyState } from "@/components/common";
import { useIsMobile } from "@/hooks/useMediaQuery";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const isMobile = useIsMobile();
  const label = params.get("label");

  useEffect(() => {
    const known = ["q", "category", "subcategory", "collection", "gift_person", "gift_occasion", "featured"];
    const qs = new URLSearchParams();
    known.forEach((k) => { if (params.get(k)) qs.set(k, params.get(k)); });
    if ([...qs.keys()].length === 0) { setProducts([]); return; }
    setLoading(true);
    api(`/products?${qs.toString()}`).then(setProducts).finally(() => setLoading(false));
  }, [params]);

  const submit = (e) => {
    e.preventDefault();
    const next = new URLSearchParams(params);
    if (q.trim()) next.set("q", q.trim()); else next.delete("q");
    next.delete("label");
    setParams(next);
  };

  const heading = label || (params.get("q") ? `Results for "${params.get("q")}"` : "Search");

  return (
    <div className="container-max fade-up" style={{ padding: isMobile ? "24px 16px 32px" : "40px 24px 48px" }}>
      <form onSubmit={submit} style={{ position: "relative", maxWidth: 560, marginBottom: 28 }}>
        <SearchIcon size={18} color={colors.mutedText} style={{ position: "absolute", left: 16, top: "50%", transform: "translateY(-50%)" }} />
        <input
          data-testid="search-input"
          autoFocus
          className="input-field"
          style={{ paddingLeft: 46, borderRadius: 999 }}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search for cups, vases, throws…"
        />
      </form>
      <h1 className="font-display" style={{ fontSize: 28, fontWeight: 700, margin: "0 0 20px" }}>{heading}</h1>

      {loading ? <ProductGridSkeleton /> : products.length === 0 ? (
        <EmptyState title="No results" message="Try another search or browse our collections." />
      ) : (
        <div className="product-grid">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
